import { createContext } from "react";

const noteContext = createContext(); //creating a context 

export default noteContext;